import { initUpstream } from "../init-stream.js";
import { toReadable } from "../to-readable.js";
import * as Proc from '@ixfx/process';
export function max(input, options) {
    const p = Proc.max();
    return process(p, `max`, input, options);
}
export function min(input, options) {
    const p = Proc.min();
    return process(p, `min`, input, options);
}
export function average(input, options) {
    const p = Proc.average();
    return process(p, `average`, input, options);
}
export function sum(input, options) {
    const p = Proc.sum();
    return process(p, `sum`, input, options);
}
export function tally(input, options = {}) {
    const countArrayItems = options.countArrayItems ?? true;
    const p = Proc.tally(countArrayItems);
    return process(p, `tally`, input, options);
}
export function rank(input, rank, options) {
    const p = Proc.rank(rank, options);
    return process(p, `rank`, input, options);
}
function process(processor, annotationField, input, options = {}) {
    const annotate = options.annotate;
    let previous;
    const skipUndefined = options.skipUndefined ?? true;
    const skipIdentical = options.skipIdentical ?? true;
    const upstream = initUpstream(input, {
        ...options,
        onValue(value) {
            const x = processor(value);
            if (x === undefined && skipUndefined)
                return;
            if (skipIdentical && x === previous)
                return;
            previous = x;
            if (annotate) {
                // eslint-disable-next-line unicorn/prevent-abbreviations
                const ret = { value };
                ret[annotationField] = x;
                upstream.set(ret);
            }
            else {
                upstream.set(x);
            }
        },
    });
    return toReadable(upstream);
}
//todo testing for annotation and non - annotated
// rankArray
// chunk, reduce
// debounce, delay
// duration, take
